import * as React from 'react'
import Helmet from 'react-helmet'
import { graphql } from 'gatsby'
import PageTypes from '../components/page-types'

const Typo3NewsPage = ({ pageContext, data }) => {
  const page = JSON.parse(data.page.internal.content)
  const relatedNews =
    data.newsPages.edges?.map((news) => {
      return news.node
    }) || []
  const final_path = pageContext.final_path
  const accessGroups = pageContext.accessGroups || []
  const content = page.content
  content.body = content.body.map((item) => JSON.parse(item))
  const parentdata = page.parentdata
  const parents = page.parents
  const eventdata = page.eventdata
  const metadata = page.metadata
  const translations = JSON.parse(page.translations)
  const pageType = page.type || ''

  page.content.related = relatedNews
  return (
    <>
      <Helmet>
        <link rel="canonical" href={process.env.PUBLIC_CDN_HOST + final_path} />
      </Helmet>

      {PageTypes[content.component]
        ? React.createElement(PageTypes[content.component], {
            key: content._uid,
            content: content,
            parentdata: parentdata,
            parents: parents,
            eventdata: eventdata,
            metadata: metadata,
            pageType: pageType,
            translations: translations,
            page: page,
            accessGroups: accessGroups,
            relatedNews: relatedNews,
          })
        : `PageType ${content.component} not created yet`}
    </>
  )
}

export const query = graphql`
  query ($uid: Int!, $limit: Int, $news_filter: Typo3NewsPageFilterInput) {
    page: typo3NewsPage(uid: { eq: $uid }) {
      internal {
        content
      }
    }
    newsPages: allTypo3NewsPage(limit: $limit, sort: { tx_headless_news_date: DESC }, filter: $news_filter) {
      edges {
        node {
          uid
          full_slug
          icon
          category_overline
          content {
            title
            main_category {
              uid
              title
              slug
              parent
              description
              images
            }
            tx_headless_news_image {
              uid
              src
              title
              description
              alternative
              copyright
            }
            tx_headless_news_teaser
          }
        }
      }
    }
  }
`

export default Typo3NewsPage
